
<span [ngClass]="[currentNumber && currentNumber.phonePrefix ? ('flag-icon-' + currentNumber.countryCode.toLowerCase()) : 'd-none']"
      class="pull-left centred-vertical selected-flag flag-icon flag"></span>
<mat-form-field>
  <mat-select [formControl]="formControl"
              [placeholder]="'LEAD_GENERATION.SHARED.CHOOSE' | translate"
              (selectionChange)="onSelectionChanged()"
              [(ngModel)]="currentNumber">
    <ngx-mat-select-search
      [formControl]="countryFilter"
      [placeholderLabel]="'LEAD_GENERATION.SHARED.SEARCH' | translate"
      [noEntriesFoundLabel]="'LEAD_GENERATION.SHARED.NO RESULT'| translate"
      clearSearchInput="true"></ngx-mat-select-search>
    <mat-option *ngFor="let country of filteredNumbers | async" [value]="country">
      <div class="w-full over-hide text-ellipsis d-flex align-item-center">
        <span [ngClass]="[country.phonePrefix.length > 0 ? ('flag-icon-' + country.countryCode.toLowerCase()): 'd-none']"
              class="pull-left flag-icon flag centred-vertical"></span>
        <span  class="pull-left p-l-1">{{country.phonePrefix}} {{country.countryName | translate}}</span>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
